import React from "react";
import Page from "../../components/Page";

import { getAllLeaders, getLeader } from "../../data/leadership";

export default function Home(props) {
  const article = props.page.fullArticle;
  console.log(article);
  const image = article.acf.leadership_bio_image;

  return (
    <div id="page" className="site">
      <Page
        disableArrow
        title={article.title.rendered}
        heroBody={props.page.acf.hero.body}
        bgImage={image.url}
        bgId={image.id}
        alt={image.alt}
        height={image.height}
        width={image.width}
        slug={"/" + article.slug}
        bottomLeft
      >
        <main id="content" className="single-story">
          <div
            className="container"
            dangerouslySetInnerHTML={{
              __html: props.page.fullArticle.content.rendered,
            }}
          />
        </main>
      </Page>
      <style jsx>{`
        @media (min-width: 960px) {
          .container {
            padding: 5rem 20rem;
          }
        }

        p,
        p *,
        ul *,
        li,
        li * {
          color: #3a434f;
          font-family: Europa, sans-serif;
        }
      `}</style>
    </div>
  );
}

///wp-json/wp/v2/posts?slug=post-slug

export async function getStaticProps({ params }) {
  let fullArticle = await getLeader(params.slug);
  console.log(fullArticle.acf.leadership_bio_image.url);

  const page = {
    acf: {
      hero: {
        title: fullArticle.title.rendered,
        body: "<p>" + fullArticle.acf.leadership_bio_title + "</p>",
        bgImage: fullArticle.acf.leadership_bio_image,
      },
    },
    fullArticle,
  };

  return {
    props: {
      page,
    },
  };
}

// export async function getStaticPaths () {
//   const leaders = await getAllLeaders()
//   const paths = leaders.map(leader => ({
//     params: leader
//   }))

//   return {
//     paths,
//     fallback: false
//   }
// }

export async function getStaticPaths() {
  const leaders = await getAllLeaders();
  console.log(leaders.map((leader) => leader.slug));

  const paths = leaders.map((leader) => ({
    params: {
      slug: leader.slug,
    },
  }));

  return {
    paths,
    fallback: false,
  };
}
